import React from "react";

const VARIANT_STYLES = {
  error: {
    background: "#fef2f2",
    border: "1px solid #fecaca",
    color: "#991b1b",
    accent: "#dc2626",
  },
  success: {
    background: "#f0fdf4",
    border: "1px solid #bbf7d0",
    color: "#166534",
    accent: "#16a34a",
  },
  info: {
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    color: "#1e40af",
    accent: "#2563eb",
  },
};

export default function Toast({ variant = "info", message, onDismiss }) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.info;

  return (
    <div
      role="alert"
      style={{
        background: styles.background,
        border: styles.border,
        color: styles.color,
        borderLeft: `4px solid ${styles.accent}`,
        borderRadius: "8px",
        padding: "0.75rem 1rem",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "flex-start",
        gap: "0.75rem",
        fontSize: "0.875rem",
        lineHeight: "1.4",
        pointerEvents: "auto",
        animation: "applicant-toast-in 180ms ease-out",
      }}
    >
      <div style={{ flex: 1, wordBreak: "break-word" }}>{message}</div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        style={{
          background: "transparent",
          border: "none",
          color: styles.color,
          cursor: "pointer",
          fontSize: "1.1rem",
          lineHeight: 1,
          padding: 0,
          opacity: 0.7,
        }}
      >
        ×
      </button>
      <style>{`
        @keyframes applicant-toast-in {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
